import { useMemo } from 'react'
import { useChecklistGeral } from '@hooks/useChecklistGeral.js'
import { getTopicoTipo } from '@utils/topicoTipo.js'

export interface ProximoPasso {
  moduloId: string
  moduloTitulo: string
  moduloIcone: string
  topicoId: string
  topicoTitulo: string
  topicoSlug: string
  acao: 'assistir' | 'usar-ferramenta' | 'ler'
}

export function useProximoPasso(): ProximoPasso | null {
  const { modulos } = useChecklistGeral()

  return useMemo(() => {
    if (!modulos.length) return null

    const modulosOrdenados = [...modulos].sort((a, b) => a.ordem - b.ordem)

    for (const modulo of modulosOrdenados) {
      const topicosOrdenados = [...modulo.topicos].sort((a, b) => a.ordem - b.ordem)

      for (const topico of topicosOrdenados) {
        if (topico.status === 'em-andamento') {
          const tipo = getTopicoTipo(modulo.id, topico.slug, topico.id)
          const acao =
            tipo === 'ferramenta' ? 'usar-ferramenta' : tipo === 'conteudo' ? 'ler' : 'assistir'

          return {
            moduloId: modulo.id,
            moduloTitulo: modulo.titulo,
            moduloIcone: modulo.icone,
            topicoId: topico.id,
            topicoTitulo: topico.titulo,
            topicoSlug: topico.slug,
            acao,
          }
        }
      }
    }

    for (const modulo of modulosOrdenados) {
      const topicosOrdenados = [...modulo.topicos].sort((a, b) => a.ordem - b.ordem)

      for (const topico of topicosOrdenados) {
        if (topico.status === 'nao-iniciado') {
          const tipo = getTopicoTipo(modulo.id, topico.slug, topico.id)
          const acao =
            tipo === 'ferramenta' ? 'usar-ferramenta' : tipo === 'conteudo' ? 'ler' : 'assistir'

          return {
            moduloId: modulo.id,
            moduloTitulo: modulo.titulo,
            moduloIcone: modulo.icone,
            topicoId: topico.id,
            topicoTitulo: topico.titulo,
            topicoSlug: topico.slug,
            acao,
          }
        }
      }
    }

    return null
  }, [modulos])
}
